import { Dialog } from "@progress/kendo-react-dialogs";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { NotificationManager } from "src/util/notify";
import InputKendoRct from "../../control-components/input/input";
import Loader from "../../control-components/loader/loader";
import ErrorHelper from "../../helper/error-helper";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import { AdminService } from "../../services/adminService";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";

function CopyRegionTemplate({ onClose, documentTemplateId, sourceRegionId }) {
  const regionData = useSelector((state) => state.getRegion);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [settingError, setSettingError] = useState(false);

  let [fields, setFields] = useState({
    regionName: "",
  });

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (!fields.regionName) {
      formIsValid = false;
      errors["regionName"] = ErrorHelper.FIELD_BLANK;
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    setSettingError(true);
    if (handleValidation()) {
      copyRegionTemplate();
    }
  };

  const copyRegionTemplate = async () => {
    setLoading(true);
    await AdminService.copyDocumentTemplateToregion(
      fields,
      documentTemplateId,
      sourceRegionId
    )
      .then((result) => {
        setLoading(false);
        NotificationManager.success("Copy Document Template to Region");
        onClose({ updated: true });
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  return (
    <Dialog
      onClose={onClose}
      title="Copy to Another Region"
      className="small-dailog width_90" width={"40%"} 
    >
      <div className="edit-Service-popup dialog-editp y-3 header-blue">
        <div className="mx-3">
          <div className="row align-items-center">
            <div className="col-12 mb-3 mt-3">
              <DropDownKendoRct
                validityStyles={settingError}
                filterable={true}
                label="Region"
                onChange={handleChange}
                data={regionData}
                value={fields.regionName}
                textField="regionName"
                name="regionName"
                dataItemKey="id"
                suggest={true}
                required={true}
                error={!fields.regionName && errors.regionName}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-bottom-line"></div>
      <div className="d-flex my-4">
        <button
          className="green-btn  btn-primary border-0 mx-3 btn-space"
          onClick={handleSubmit}
        >
          Submit
        </button>
        <button className="btn grey-secondary btn-space " onClick={onClose}>
          Cancel
        </button>
      </div>
    </Dialog>
  );
}
export default CopyRegionTemplate;
